module.exports = __webpack_public_path__ + "img/workshop-marker-v1.7467687e.png";